import toast from 'react-hot-toast';

/**
 * Custom toast utilities with consistent styling
 * react-hot-toast v2.6.0 supports: toast(), toast.success(), toast.error(), toast.loading()
 * For other types, we use custom styling with icons
 */

export const customToast = {
  // Standard methods
  success: (message, options = {}) => {
    return toast.success(message, {
      duration: 3000,
      ...options
    });
  },

  error: (message, options = {}) => {
    return toast.error(message, {
      duration: 4000,
      ...options
    });
  },

  loading: (message, options = {}) => {
    return toast.loading(message, options);
  },

  // Custom methods with icons
  info: (message, options = {}) => {
    return toast(message, {
      icon: 'ℹ️',
      duration: 3000,
      style: {
        background: '#E3F2FD',
        color: '#1565C0',
        border: '1px solid #BBDEFB'
      },
      ...options
    });
  },

  warning: (message, options = {}) => {
    return toast(message, {
      icon: '⚠️',
      duration: 4000,
      style: {
        background: '#FFF3E0',
        color: '#E65100',
        border: '1px solid #FFCC02'
      },
      ...options
    });
  },

  promise: (promise, messages, options = {}) => {
    return toast.promise(promise, messages, {
      style: {
        minWidth: '250px',
      },
      ...options
    });
  },

  // Dismiss methods
  dismiss: (toastId) => {
    return toast.dismiss(toastId);
  },

  dismissAll: () => {
    return toast.dismiss();
  }
};

// Export individual methods for convenience
export const {
  success: toastSuccess,
  error: toastError,
  loading: toastLoading,
  info: toastInfo,
  warning: toastWarning,
  promise: toastPromise,
  dismiss: toastDismiss,
  dismissAll: toastDismissAll
} = customToast;

// Default export for backward compatibility
export default customToast;